/* eslint-disable indent */
import styled from "styled-components";

import { device } from "utils/sizes";
import { colourScheme } from "utils/styling/colours";

export const ArtStyleSelect = styled.div<{ isDisabled?: boolean }>`
    display: flex;
    align-items: center;
    padding: 0.5rem;

    flex-grow: 2;
    min-width: 7rem;
    border: 1px solid ${colourScheme.primaryLight};
    border-radius: 0.5rem;
    cursor: ${({ isDisabled }) => (isDisabled ? "not-allowed" : "pointer")};
    background-color: ${colourScheme.primary};

    &:hover {
        background-color: ${({ isDisabled }) =>
            isDisabled ? colourScheme.grey : colourScheme.primaryLight};
    }

    span {
        margin-left: 0.5rem;
        font-weight: bold;
    }

    img {
        border-radius: 0.5rem;
    }

    ${device.md} {
        min-width: 10rem;
    }
`;

export const ArtStyleContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: center; /* Center the items horizontally */
    gap: 1rem; /* Add gap between items */
`;

export const ArtStyleCard = styled.div`
    border: 1px solid ${colourScheme.primaryLight};
    background-color: ${colourScheme.primary};
    border-radius: 0.5rem;
    padding: 1rem;
    cursor: pointer;
    text-align: center;
    box-shadow: 0 0.625rem 1.25rem rgba(0, 0, 0, 0.5);
    transition: transform 0.2s ease-in-out;

    flex: 1 1 200px; /* Allow the card to grow and shrink */
    max-width: 300px; /* Set a maximum width */
    margin: 0.5rem; /* Add margin for spacing */

    &:hover {
        transform: scale(1.05);
    }
`;

export const ModalContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;

    max-width: 100vw;
    width: 100%;
    padding: 1rem;
    max-height: 90vh;
    min-height: 50vh;
    overflow-y: auto;

    ${device.lg} {
        max-width: 70vw;
    }

    ${device.xl} {
        max-width: 60vw;
    }
`;

export const DefaultModelContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.5rem;
    padding: 0.5rem;
`;

export const LabelWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
`;

export const ArtStyleName = styled.div`
    margin-top: 0.5rem;
    font-weight: bold;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;

    ${device.xl} {
        flex-direction: row;
        justify-content: space-between;
    }
`;

export const SubscriberOnlyBadge = styled.div`
    background: linear-gradient(
        90deg,
        ${colourScheme.alertLight} 0%,
        ${colourScheme.alertDark} 100%
    );
    color: ${colourScheme.primary};
    padding: 0.25rem 0.5rem;
    border-radius: 1rem;
    font-size: 0.75rem;
    font-weight: bold;
    margin-top: 0.5rem;

    ${device.md} {
        margin-left: 0.5rem;
        margin-top: 0.5rem;
    }

    ${device.xl} {
        white-space: nowrap;
    }
`;

export const NewBadge = styled.div`
    background: linear-gradient(
        90deg,
        ${colourScheme.successLight} 0%,
        ${colourScheme.successDark} 100%
    );
    color: ${colourScheme.primary};
    padding: 0.25rem 0.5rem;
    border-radius: 1rem;
    font-size: 0.75rem;
    font-weight: bold;
    margin-top: 0.5rem;

    ${device.md} {
        margin-left: 0.5rem;
        margin-top: 0.5rem;
    }

    ${device.xl} {
        white-space: nowrap;
    }
`;

export const SearchInput = styled.input`
    width: 100%;
    padding: 0.5rem;
    margin-bottom: 1rem;
    border: 1px solid ${colourScheme.primaryLight};
    background-color: ${colourScheme.primaryDark};
    color: ${colourScheme.white};
    border-radius: 4px;
    font-size: 1rem;

    &:focus {
        outline: none;
        border-color: ${colourScheme.primary};
        box-shadow: 0 0 0 2px ${colourScheme.primaryLight};
    }
`;
export const SearchContainer = styled.div`
    width: 100%;
    padding: 0.5rem;
    background-color: ${colourScheme.primary};
    border-radius: 0.5rem;
    margin-bottom: 1rem;
    position: sticky;
    top: 0;
    z-index: 1000;
    box-shadow: 0 0.625rem 1.25rem rgba(0, 0, 0, 0.5);
`;
